<template>
  <b-modal
          title="Selection des fiches d'espaces"
          :modal-class="'base-modal'"
          centered
          ref="espaceSelectionModal"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
  >
    <b-container fluid>
      <loading class="small" v-if="loading()" />
      <div v-else-if="!loading()" class="text-edit">
        <template v-if="hasFiches">
          <h2 class="sub-title">Choix des fiches</h2>
          <p class="info">
            Veuillez choisir les fiches d'espaces auxquelles appliquer la
            structure actuelle.
          </p>

          <b-form-group>
            <b-form-checkbox v-model="allSelected" @change="toggleAll()">
              {{ allSelected ? "Tout déselectionner" : "Tout sélectionner" }}
            </b-form-checkbox>
            <hr />
            <vue-custom-scrollbar class="check-description-area" :settings="settings">
              <b-form-checkbox-group
                      v-model="selected"
                      :options="options"
                      name="fiches-espaces"
                      stacked
              ></b-form-checkbox-group>
            </vue-custom-scrollbar>
          </b-form-group>

        </template>
        <template v-else>
          <h2 class="sub-title">Choix des fiches</h2>
          <p class="info text-info">
            Vous n'avez actuellement pas d'autres fiches d'espaces auxquelles appliquer cette structure.
          </p>
        </template>
      </div>
    </b-container>

    <div v-if="!loading()" slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
                variant="outline-primary"
                size="md"
                class="mx-2"
                @click="close"
        >
          Annuler
        </b-button>
        <b-button variant="primary" size="md" @click="applyStructure">
          Appliquer
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import iconBase from '../../icons/iconBase'
import loading from '../../loading'
import { mapGetters, mapActions } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'
export default {
  components: {
    iconBase,
    loading,
    vueCustomScrollbar
  },
  computed: {
    hasFiches () {
      if (!!this.options === false) {
        return false
      }
      return !!this.options.length
    }
  },
  data () {
    return {
      selected: [],
      options: null,
      allSelected: false,
      settings: {
        maxScrollbarLength: 60
      }
    }
  },
  watch: {
    selected: {
      handler (val) {
        this.allSelected = !!this.options && val.length === this.options.length
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['getFicheEspacesListByOnglet', 'setLoading']),
    ...mapGetters(['loading', 'templateId', 'currentFicheData', 'ficheTableauData']),
    close () {
      this.selected = []
      this.options = null
      this.$refs['espaceSelectionModal'].hide()
    },
    getFicheTitle (onglet, ligne) {

    },
    async open () {
      this.$refs['espaceSelectionModal'].show()
      this.setLoading(true)
      const resp = await this.getFicheEspacesListByOnglet()
      const mappedData = this.ficheTableauData().reduce((acc, curr, index) => {
        if (!this.ficheTableauData()[index].columns) {
          acc[`${curr.id}`] = {
            data: curr.data,
            denominationIndex: -1
          }
        } else {
          const denominationIndex = this.ficheTableauData()[index].columns.findIndex(el => el.key === 'H1')
          acc[`${curr.id}`] = {
            data: curr.data,
            denominationIndex,
            rows: this.ficheTableauData()[index].rows
          }
        }
        return acc
      }, {})

      var newResp = JSON.parse(window.localStorage.getItem('ficheData'))
      this.options = newResp.map((el, index) => {
        // const denominationIndex = mappedData[el.onglet].denominationIndex

        if (el.denomination < 0 || el.isEnsemble === true) {
          return null
        }

        // console.log(mappedData[el.onglet].data[el.ligne][denominationIndex] + ' ' + el.id)
        return {
          text: el.denomination,
          // type: mappedData[el.onglet].rows[ligne].type,
          value: {
            id: el.ficheId,
            onglet: el.onglet,
            ligne: el.ligne,
            data: el.data
          },
          deprecated: false //! mappedData[el.onglet].rows[el.ligne] || mappedData[el.onglet].rows[el.ligne].fiche !== el.id
        }
      }).filter(el => el && !el.deprecated && el.type !== 'ensemble')
        .sort((a, b) => a.value.ligne - b.value.ligne)
      this.setLoading(false)

      console.log(this.options)
    },
    // async open () {
    //     this.$refs['espaceSelectionModal'].show()
    //     this.setLoading(true)
    //     const resp = await this.getFicheEspacesListByOnglet()
    //     const mappedData = this.ficheTableauData().reduce((acc, curr, index) => {
    //         if (!this.ficheTableauData()[index].columns) {
    //             acc[`${curr.id}`] = {
    //                 data: curr.data,
    //                 denominationIndex: -1
    //             }
    //         } else {
    //             const denominationIndex = this.ficheTableauData()[index].columns.findIndex(el => el.key === 'H1')
    //             acc[`${curr.id}`] = {
    //                 data: curr.data,
    //                 denominationIndex,
    //                 rows: this.ficheTableauData()[index].rows
    //             }
    //         }
    //         return acc
    //     }, {})
    //
    //   console.log('IM HERE')
    //     this.options = resp.filter(re => this.currentFicheData().ligne + '' !== re.ligne).map(el => {
    //         const denominationIndex = mappedData[el.onglet].denominationIndex
    //
    //         if (denominationIndex < 0 || el.isEnsemble === true) {
    //             return null
    //         }
    //
    //         if (mappedData[el.onglet].data[el.ligne][denominationIndex] === '') {
    //           //return null
    //         }
    //
    //         console.log(el)
    //
    //       return {
    //         text: mappedData[el.onglet].data[el.ligne][denominationIndex] + ' ' + el.id,
    //         type: '', // mappedData[el.onglet].rows[el.ligne].type
    //         value: {
    //           id: el.id,
    //           onglet: el.onglet,
    //           ligne: el.ligne,
    //           data: el.data
    //         },
    //         deprecated: false //!mappedData[el.onglet].rows[el.ligne] || mappedData[el.onglet].rows[el.ligne].fiche !== el.id
    //       }
    //     }).filter(el => el && !el.deprecated && el.type !== 'ensemble')
    //         .sort((a, b) => a.value.ligne - b.value.ligne)
    //     this.setLoading(false)
    //
    //     console.log(this.options)
    // },
    toggleAll () {
      this.selected = !this.allSelected ? this.options.map(el => (el.value)) : []
    },
    applyStructure () {
      if (this.selected.length) {
        this.$emit('apply', this.selected)
      }
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
  .small {
    position: relative;
  }
  .text-edit {
    margin-top: 0px;
    width: 100%;
    p.info {
      font-style: italic;
      color: rgba(0, 0, 0, 0.5);
      font-size: 13px;
      text-align: left;
    }
    h2.sub-title {
      margin-top: 0px;
      font-size: 16px;
      font-weight: 600;
      text-align: left;
    }
  }

  .check-description-area {
    height: calc(100vh - 450px);
    margin-right: -15px;
    // padding-right: 15px;
    .ps__thumb-x,
    .ps__thumb-y {
      background-color: #2b3085 !important;
      width: 6px !important;
      right: 0;
      &:hover {
        background-color: #2b3085;
        width: 6px;
      }
    }
    .ps__rail-y {
      display: block;
      width: 8px;
      border: 1px solid #2b3085;
      border-radius: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/modal/selectionEspace.vue